import { ActionButton, SearchBox } from '@fluentui/react';
import OptionPicker from '../../../../common/views/OptionPicker';
import { Utils } from '../../../../common/views/Utils';
import { OrderFilterModel, OrderStatus } from '../../../models/OrderModel';
import { OptionModel } from '../../../../home/models/OtherTypes';

export type OrderHeaderProps = {
    filter: OrderFilterModel;
    statuses: OptionModel[];
    setStatuses: (newOptions: OptionModel[]) => void;
    setShowAdd: (value: boolean) => void;
    onShowFilter: () => void;
    onValueChange: (field: keyof OrderFilterModel, value: any) => void;
    onGetList: (getCount: boolean, pageChange: boolean) => void;
}

export default function OrderHeaderView({
    filter, statuses, setStatuses, onValueChange, onGetList, setShowAdd, onShowFilter
}: OrderHeaderProps) {
    const width6 = Utils.getColumnWidth(6, 12, 12);

    const onStatusChange = (status: OrderStatus) => {
        filter.status = status;
        filter.pageNumber = 1;
        onGetList(false, false);
    }

    const searchInput = () => {
        return <>
            <SearchBox
                autoFocus={false}
                value={filter.search}
                placeholder="Search"
                onChange={(_, newValue) => onValueChange("search", newValue || "")}
                onSearch={(value: string) => onGetList(true, false)}
                className="searchbox"
                styles={{ root: { width: "200px", display: "inline-flex" } }}
            />
        </>;
    }

    const refreshButton = () => {
        return <>
            <ActionButton
                iconProps={{ iconName: "Refresh" }}
                onClick={() => onGetList(true, false)}
            >Refresh</ActionButton>
        </>;
    }

    const addButton = () => {
        return <>
            <ActionButton
                iconProps={{ iconName: "Add" }}
                onClick={() => setShowAdd(true)}
            >Add New</ActionButton>
        </>;
    }

    const filterButton = () => {
        return <>
            <ActionButton
                iconProps={{ iconName: "Filter" }}
                onClick={onShowFilter}
            >Filter</ActionButton>
        </>;
    }

    const actionElements = () => {
        return <>
            {searchInput()}
            {addButton()}
            {filterButton()}
            {refreshButton()}
        </>;
    }

    const statusPicker = () => {
        return <>
            <OptionPicker
                options={statuses}
                setOptions={setStatuses}
                onChange={onStatusChange}
                padding={8}
            />
        </>;
    }

    return <>
        <div className="ms-Grid-row pv-5 blue-background ml-0 mr-0">
            <div className={width6 + " left"}>
                {actionElements()}
            </div>
            <div className={width6 + " right pt-8"}>
                <div style={{ display: "inline-block" }}>
                    {statusPicker()}
                </div>
            </div>
        </div>
    </>;
}